import {
  ISideOffsets,
  LocationDirection,
  Side,
  TranslateFunction,
} from "../models/Common"
import { GlassOrder, GlassOrderStrings } from "../models/Layers"
import { ProductType } from "../models/Product"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "./Base"
import { Glass } from "./Glass"

export class PrintedBorder extends BaseComponent {
  public constructor(
    id: number,
    color: string,
    glass: Glass,
    doublePrint: boolean,
    frameThickness: ISideOffsets,
    onGlass: GlassOrder,
    t: TranslateFunction
  ) {
    super(
      {
        id,
        color: "#6ced48",
        description: `${t("d_print_w_color", { color: color })}${
          doublePrint ? `, ${t("d_double_print")}` : ""
        }, ${t("d_on_glass", {
          glass: GlassOrderStrings(ProductType.FortouchO, true, t)[onGlass],
        })}`,
      } as IComponentInfo,
      {
        width: glass.shape.width - frameThickness.r - frameThickness.l,
        height: glass.shape.height - frameThickness.b - frameThickness.t,
        centralOffsetX:
          0.5 * (frameThickness.l - frameThickness.r) +
          glass.shape.centralOffsetX,
        centralOffsetY:
          0.5 * (frameThickness.t - frameThickness.b) +
          glass.shape.centralOffsetY,
      } as IComponentShape,
      {
        dimensions: {
          sides: [Side.Top, Side.Left],
          diff: true,
          reference: glass.shape,
        },
        description: false,
        id: {
          locationDirection: LocationDirection.Inward,
          fromSide: Side.Right,
          padding: 20,
          perpendicularOffset: 25,
        },
      } as IComponentLabels
    )
  }
}
